const CheckIcon = () => {
  return (
    <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
      <circle cx="16" cy="16" r="14" fill="#22c55e" fillOpacity="0.2" stroke="#22c55e" strokeWidth="2"/>
      <path 
        d="M9 16 L14 21 L23 11" 
        stroke="#22c55e" 
        strokeWidth="3" 
        strokeLinecap="round" 
        strokeLinejoin="round"
        fill="none"
      />
    </svg>
  );
};

export default CheckIcon;

